import api from "../api";
const routes = require("routes.js.erb");

const getCampaignModals = function({ commit }) {
  return api
    .get(routes.api_v5_campaign_modals_path())
    .then((response) => commit("setCampaignModals", response.data.data.campaign_modals));
};

const deleteCampaignModals = function({ commit }) {
  return api
    .delete(routes.api_v5_campaign_modal_destroy_all_path())
    .then((_response) => commit("setCampaignModals", []));
};

export { getCampaignModals, deleteCampaignModals };
